import i18next from 'i18next';
import React from 'react';

import { Button, Tooltip } from '@commons/utils/styledLibraryComponents';
import sortActionsList from '@commons/utils/sortActionsList';

const getGlobalActions = ({
  selectedItems,
  hasCentralKitchensAvailableToAdd,
  handleOpenAddCentralKitchensModal,
  handleDisableSupplierProducts,
}) => {
  const hasSelectedItems = !!selectedItems.length;

  const hasOnlyInactiveSelected = hasSelectedItems && selectedItems.every(({ active }) => !active);

  const isDeactivationDisabled = !hasSelectedItems || hasOnlyInactiveSelected;

  const getDeactivationDisabledTooltipText = () => {
    if (!hasSelectedItems) {
      return i18next.t('ADMIN.CENTRAL_PRODUCTS.DEACTIVATE_SELECTION_EMPTY_TOOLTIP');
    }

    return i18next.t('ADMIN.CENTRAL_PRODUCTS.DEACTIVATE_INACTIVE_DISABLED_TOOLTIP');
  };

  return sortActionsList([
    {
      fixed: true,
      id: 'action-add',
      actionLabel: i18next.t('GENERAL.ADD'),
      render: () => (
        <>
          {hasCentralKitchensAvailableToAdd && (
            <Button
              color={'inpulse-default'}
              handleClick={handleOpenAddCentralKitchensModal}
              icon="/images/inpulse/add-white-small.svg"
              label={i18next.t('GENERAL.ADD')}
            />
          )}
          {!hasCentralKitchensAvailableToAdd && (
            <Tooltip
              displayBigger={true}
              renderTooltipTrigger={() => (
                <Button
                  color={'inpulse-default'}
                  handleClick={() => {}}
                  icon="/images/inpulse/add-white-small.svg"
                  isDisabled={true}
                  label={i18next.t('GENERAL.ADD')}
                />
              )}
              text={i18next.t('ADMIN.CENTRAL_PRODUCTS.ADD_CENTRAL_KITCHENS_DISABLED_TOOLTIP')}
            />
          )}
        </>
      ),
      handleAction: () => {},
    },
    {
      id: 'disable',
      actionLabel: i18next.t('ADMIN.CENTRAL_PRODUCTS.DEACTIVATE_CENTRAL_KITCHEN_ACTION', {
        count: selectedItems.length || 1,
      }),
      handleAction: () => handleDisableSupplierProducts(selectedItems),
      actionIcon: () =>
        isDeactivationDisabled
          ? '/images/inpulse/power-lmgrey-small.svg'
          : '/images/inpulse/power-black-small.svg',
      isDisabled: () => isDeactivationDisabled,
      disabledTooltipText: getDeactivationDisabledTooltipText,
    },
  ]);
};

const getRowActions = ({ handleSetReference, handleDisableSupplierProducts }) =>
  sortActionsList([
    {
      id: 'set-reference',
      actionLabel: () => i18next.t('ADMIN.CENTRAL_PRODUCTS.SET_REFERENCE_ACTION'),
      handleAction: (item) => handleSetReference(item),
      actionIcon: () => '/images/inpulse/sync-black-small.svg',
      isHidden: (item) => !item.active || item.isReference,
    },
    {
      id: 'disable',
      actionLabel: () =>
        i18next.t('ADMIN.CENTRAL_PRODUCTS.DEACTIVATE_CENTRAL_KITCHEN_ACTION', { count: 1 }),
      handleAction: (item) => handleDisableSupplierProducts([item]),
      actionIcon: () => '/images/inpulse/power-black-small.svg',
      isHidden: (item) => !item.active,
    },
  ]);

export default { getGlobalActions, getRowActions };
